import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  LanguageSwitcherItem,
  segmentedButtonType,
} from './segmented-control-button/segmented-control-button.component';

@Component({
  selector: 'rt-segmented-control',
  templateUrl: './segmented-control.component.html',
  styleUrls: ['./segmented-control.component.less'],
  host: {
    '[class.full-width]': 'fullwidth',
    '[class.no-wrap]': 'noWrap',
  },
})
export class SegmentedControlComponent<T> {
  @Input() public type: 'view-switcher' | 'multilang-switcher';
  @Input() public fullwidth: boolean;
  @Input() public segmentedButtons: Array<segmentedButtonType<any>>;
  @Input() public languages: LanguageSwitcherItem[] = [];
  @Input() public activeLanguage: string;
  @Input() public loadingLanguageCode: string | null = null;
  @Input() public fieldsCount: number;
  @Input() public primaryLanguageLabel = 'app.common.default';
  @Input() public isDisabled: boolean | undefined;
  @Input() public isAvailable: boolean;
  @Input() public noWrap: boolean;

  @Output() public segmentedButtonClicked: EventEmitter<T | LanguageSwitcherItem> =
    new EventEmitter<T | LanguageSwitcherItem>();

  public trackByFn(index: number, item: segmentedButtonType<T>): T | number {
    return item.value || index;
  }

  public trackByLangCode(index: number, item: LanguageSwitcherItem): string | number {
    return item.code || index;
  }
}
